import React, { useState } from 'react'
import styles from './FocusAddTaskInput.module.css'

export type FocusAddTaskInputProps = {
  placeholder?: string
  onSubmit?: (value: string) => void
}

const FocusAddTaskInput = ({
  placeholder = 'Plant a new intention...',
  onSubmit,
}: FocusAddTaskInputProps) => {
  const [value, setValue] = useState('')

  const submit = () => {
    const trimmed = value.trim()
    if (!trimmed) return
    onSubmit?.(trimmed)
    setValue('')
  }

  return (
    <div className={styles.wrapper}>
      <span className={styles.plus} aria-hidden>
        +
      </span>
      <input
        type="text"
        className={styles.input}
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') submit()
        }}
        aria-label={placeholder}
      />
    </div>
  )
}

export default FocusAddTaskInput
